import React from "react";
import LogIn from "../components/LogIn/LogIn";
import ScrollToTop from "../components/ScrollToTop";

const LogInPage = () => {
  return (
    <div>
      <ScrollToTop />
      <LogIn />
    </div>
  );
};

export default LogInPage;
